import React from 'react'
import styled from 'styled-components'

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  background-color: #000000;
`

const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const GroupLegend = styled.legend`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #9ca3af;
  margin-bottom: 0.25rem;
`

const GroupList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 0;
`

const ListItem = styled.li`
  display: flex;
`

const Divider = styled.div`
  height: 1px;
  background-color: #1f2937;
  margin: 0.625rem 0;
`

const NavButton = styled.button`
  width: 261px;
  height: 27px;
  position: relative;
  left: -11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 11px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.02em;
  border-radius: 3px;
  transition: all 0.15s;
  border: none;
  cursor: ${props => (props.$disabled ? 'default' : 'pointer')};
  text-align: left;
  background-color: ${props => (props.$isActive ? '#323232' : 'transparent')};
  color: ${props => {
    if (props.$disabled) return '#6b7280'
    if (props.$isActive) return '#ffffff'
    return '#d1d5db'
  }};
  opacity: ${props => (props.$disabled ? 0.6 : 1)};

  &:hover {
    background-color: ${props => {
      if (props.$disabled) return 'transparent'
      if (props.$isActive) return '#323232'
      return '#1f2937'
    }};
    color: ${props => (props.$disabled ? '#6b7280' : '#ffffff')};
  }
`

const NavButtonLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 0.375rem;
`

const SoonBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.0625rem 0.375rem;
  border-radius: 9999px;
  font-size: 0.5625rem;
  font-weight: 600;
  background-color: #374151;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

const navigationGroups = [
  {
    title: 'General Settings',
    items: [
      { id: 'general', name: 'My clinic' },
      { id: 'profile', name: 'My profile' },
    ],
  },
  {
    title: 'Office Settings',
    items: [
      { id: 'scheduling', name: 'Scheduling' },
      { id: 'rooms', name: 'Rooms' },
      { id: 'appointment-types', name: 'Appointment types' },
      { id: 'doctors', name: 'Doctors' },
      { id: 'labels', name: 'Labels' },
      { id: 'reminders', name: 'Reminders' },
      { id: 'finance', name: 'Finance' },
      { id: 'users', name: 'Manage users' },
    ],
  },
  {
    title: 'Feature Settings',
    items: [
      { id: 'booking-pages', name: 'Booking pages' },
      { id: 'reschedule', name: 'Rescheduling' },
      { id: 'patient-documents', name: 'Patient documents' },
      { id: 'mailers', name: 'Mailers', soon: true, disabled: true },
    ],
  },
]

const SettingsNavigation = ({ activeTab, onTabChange }) => {
  const handleItemClick = item => {
    if (item.disabled) return
    onTabChange(item.id)
  }

  return (
    <Nav>
      {navigationGroups.map((group, groupIndex) => (
        <React.Fragment key={groupIndex}>
          {groupIndex > 0 && <Divider />}
          <GroupContainer>
            <GroupLegend>{group.title}</GroupLegend>
            <GroupList>
              {group.items.map(item => (
                <ListItem key={item.id}>
                  <NavButton
                    onClick={() => handleItemClick(item)}
                    $isActive={activeTab === item.id}
                    $disabled={item.disabled}
                  >
                    <NavButtonLabel>
                      {item.name}
                      {item.soon && <SoonBadge>SOON</SoonBadge>}
                    </NavButtonLabel>
                  </NavButton>
                </ListItem>
              ))}
            </GroupList>
          </GroupContainer>
        </React.Fragment>
      ))}
    </Nav>
  )
}

export default SettingsNavigation
